import { type ISelectInputProps } from '@framework/form/inputs/SelectInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { SimilInputSpan } from '../../../../../../ui/form/SimilInputSpan.tsx';
import { $SpaceCompact } from '../../../../../../ui/form/SpaceCompact.ts';
import { AsyncServiceSelectInput } from '../../../../../expressions/repository/async/input/AsyncServiceSelectInput.tsx';

export interface IServiceSelectorInputProps {
  onChange: ISelectInputProps['onChange'];
  name: string;
  label?: string;
}

export function ServiceSelectorInput(props: IServiceSelectorInputProps) {
  const { onChange, name } = props;
  return (
    <FormItem label="" name={name}>
      <$SpaceCompact size="large" block>
        <SimilInputSpan>{props.label ?? 'Servizio'}</SimilInputSpan>

        <AsyncServiceSelectInput
          name={name}
          style={{ width: '100%' }}
          onChange={onChange}
        />
      </$SpaceCompact>
    </FormItem>
  );
}
